/* Component in the Callsheet component to display the Callsheet 
   Company Contact info in mobile */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";

const ContactsPage2 = (props) => {
    const {crewInfoOne, setShow, callsheet} = props;
    const {production_company, company_phone, company_email,
        company_address_line_1, company_address_line_2, company_address_line_3,
        company_address_line_4,
        producer_name, producer_phone,
        pro_coordinator_name, pro_coordinator_phone,} = crewInfoOne;

    const {location_1_address, location_2_address,
      location_3_address, location_4_address
    } = callsheet;
    
  return (
    <div className='mt-3'>
        <div className={`mb-3 text-center ${styles.SubTitleSpan }`}>
        <span className={`float-right ${styles.Close }`} onClick={() => setShow(false) } >Close</span> 
        <h4 className={`pl-5 text-center`} 
        style={{ textTransform: 'uppercase'}} >Contacts </h4>
        </div>
        <Row>
        <Col xs={12} className='ml-5' >
            <div >
            <Row className='mb-1'>
              <Col xs={{span: 10, offset: 0}}>
              <p className={`mb-0 ${styles.BoldScene} `} >Production Company: </p>
              <h5 className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{production_company} </h5>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{company_address_line_1} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{company_address_line_2} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{company_address_line_3} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{company_address_line_4} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>Phone {company_phone} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>Email {company_email} </p>
              </Col>
            </Row>
            </div>
            <div className='mt-3'>
            {/* Producer */}
            <Row>
              <Col xs={12} >
              <p className={`mb-1`} ><span className={`${styles.BoldScene}`}>Producer:</span > </p>
              </Col>
              <Col xs={12} >
              <p className={`${styles.WhiteAqua} mb-1`} >{producer_name} - {producer_phone} </p>
              </Col>
            </Row>
            {/* pro-cor */}
            <Row>
              <Col xs={12} >
              <p className={`mb-1`} ><span className={`${styles.BoldScene}`}>Production Coordinator:</span></p>
              </Col>
              <Col xs={12} >
              <p className={`${styles.WhiteAqua} mb-1`} >{pro_coordinator_name} - {pro_coordinator_phone}</p>
              </Col>
            </Row>
            {/* Director */}
            <Row>
              <Col xs={12} >
              <p className={`mb-1`} ><span className={`${styles.BoldScene}`}>2nd Unit Director:</span></p>
              </Col>
              <Col xs={12} >
              <p className={`${styles.WhiteAqua} mb-1`}>{location_1_address} - {location_2_address} </p>
              </Col>
            </Row>
            {/* 1st AD */}
            <Row>
              <Col xs={12} >
              <p className={`mb-1`} ><span className={`${styles.BoldScene}`}>2nd Unit 1st AD:</span></p>
              </Col>
              <Col xs={12} >
              <p className={`${styles.WhiteAqua} mb-1`}>{location_3_address} - {location_4_address} </p>
              </Col>
            </Row>
            </div>
            </Col>
        </Row>
    </div>
  )
}

export default ContactsPage2